import { Button } from 'antd';
import ButtonGroup from 'antd/es/button/button-group.js';
import { HeatMapOutlined, SettingOutlined } from '@ant-design/icons';
import { useUnit } from 'effector-react';
import style from './TopFilters.module.css';
import {
  $activeModal,
  changeActiveModalEv,
} from '../../models/investProModel/index.js';

function TopFilters() {
  const changeActiveModal = useUnit(changeActiveModalEv);
  const activeModal = useUnit($activeModal);

  return (
    <div className={style.top_fitlers_wrapper}>
      <Button
        size="large"
        icon={<SettingOutlined />}
        iconPosition="end"
        onClick={() => changeActiveModal('regions')}
        className="glass"
      >
        Регионы
      </Button>
      {/* <Button size="large">Hotels</Button> */}
      <Button
        size="large"
        icon={<SettingOutlined />}
        iconPosition="end"
        onClick={() => changeActiveModal('projects')}
        className="glass"
      >
        Спец слои
      </Button>
      <Button
        size="large"
        icon={<HeatMapOutlined />}
        iconPosition="end"
        onClick={() => changeActiveModal('heatmap')}
        className="glass"
      >
        Тепловая карта
      </Button>
      {/* <Button size="large">Special Economic Zones</Button> */}
      {/* <Button size="large">Industrial Zones</Button> */}
      {/* <ButtonGroup> */}
      {/*  <Button size="large">Infrastructure Objects</Button> */}
      {/*  <Button size="large" icon={<SlidersOutlined />} /> */}
      {/* </ButtonGroup> */}
      {/* <ButtonGroup> */}
      {/*  <Button size="large">Population Density</Button> */}
      {/*  <Button size="large" icon={<SlidersOutlined />} /> */}
      {/* </ButtonGroup> */}
      {/* <Button size="large">Universities</Button> */}
    </div>
  );
}

export default TopFilters;
